export var selectUserDeliveryZone = function selectUserDeliveryZone(state) {
  var _state$userConfigurat;
  return (_state$userConfigurat = state.userConfiguration) === null || _state$userConfigurat === void 0 ? void 0 : _state$userConfigurat.deliveryZone;
};
export var selectUserCurrencyCode = function selectUserCurrencyCode(state) {
  var _state$userConfigurat2;
  return (_state$userConfigurat2 = state.userConfiguration) === null || _state$userConfigurat2 === void 0 ? void 0 : _state$userConfigurat2.currencyCode;
};
export var selectCookieConsent = function selectCookieConsent(state) {
  var _state$userConfigurat3;
  return (_state$userConfigurat3 = state.userConfiguration) === null || _state$userConfigurat3 === void 0 ? void 0 : _state$userConfigurat3.cookieConsent;
};
export var selectUserCountryCode = function selectUserCountryCode(state) {
  var _state$userConfigurat4;
  return (_state$userConfigurat4 = state.userConfiguration) === null || _state$userConfigurat4 === void 0 ? void 0 : _state$userConfigurat4.countryCode;
};
export var selectFeatureFlags = function selectFeatureFlags(state) {
  var _state$userConfigurat5;
  return (_state$userConfigurat5 = state.userConfiguration) === null || _state$userConfigurat5 === void 0 ? void 0 : _state$userConfigurat5.featureFlags;
};